import { get as getTimezones } from 'dynamic-data/timezones';

let cachedOffsets;

export const getOffsets = () => {
  let offsets;

  if (__SERVER__) {
    const moment = require('moment-timezone');

    const tzStrToMinuteOffset = str =>
      (parseInt(str.substring(1, 3), 10) * 60 + parseInt(str.substring(3, 5), 10)) * (str[0] === '-' ? 1 : -1);

    offsets = getTimezones().reduce(
      (memo, tz) => ({
        ...memo,
        [tz]: tzStrToMinuteOffset(
          moment()
            .tz(tz)
            .format('ZZ')
        ),
      }),
      {}
    );
  } else if (__CLIENT__) {
    if (!cachedOffsets) {
      const configNode = document.getElementById('tz-offsets');
      cachedOffsets = JSON.parse(configNode.textContent);
    }
    offsets = cachedOffsets;
  }

  if (!offsets) {
    throw new Error('Could not find TZ offsets.');
  }

  return offsets;
};

const isSupportedTimezone = timezone => getTimezones().indexOf(timezone) >= 0;

/* Adds or subtracts an offset from a UTC timestamp to "shift" the timestamp
 * backwards or forwards so it renders correctly in the browser. JS's Date()
 * function treats all dates as UTC -- this works fine if you are looking at
 * a schedule for a venue in NYC on a computer set to EST. However, if you are
 * set to a DIFFERENT timezone from the studio, you'll see the class times in
 * *your* local timezone which is confusing.
 */
const shiftTimezone = (timestamp, timezone) => {
  if (isSupportedTimezone(timezone)) {
    const browserOffset = new Date().getTimezoneOffset();
    const actualOffset = getOffsets()[timezone];
    const minuteDifference = actualOffset - browserOffset;
    return timestamp - minuteDifference * 60;
  }

  return timestamp;
};

export const shiftDateObjectByTimezone = (date, timezone) =>
  new Date(shiftTimezone(date.valueOf() / 1000, timezone) * 1000);

export default shiftTimezone;
